var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMagnifyingGlass = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#171C1E",
  fillRule: "evenodd",
  d: "M7.2 2.8a4.4 4.4 0 1 0 0 8.8 4.4 4.4 0 0 0 0-8.8M1.6 7.2a5.6 5.6 0 1 1 9.961 3.513l2.663 2.663a.6.6 0 0 1-.848.848l-2.663-2.663A5.6 5.6 0 0 1 1.6 7.2",
  clipRule: "evenodd",
  opacity: 0.7
})));
export { SvgMagnifyingGlass as ReactComponent };